import * as Yup from 'yup'

import { GeneratePurchaseOrderPayloadSupplyItemProps } from '@/types'
import { GeneratePurchaseOrderValues } from '../../helpers'

export const schemaPO = (t: (key: string) => string) => ({
  supplierUuid: Yup.string().required(t('requiredMessage')),
  purchaseOrderCode: Yup.string().required(t('requiredMessage')),
  items: Yup.array()
    .of(Yup.mixed())
    .required(t('requiredMessageItems'))
    .min(1, t('requiredMessageItems')),
})

export const schema = (t: (key: string) => string) => ({
  supplierUuid: Yup.string().required(t('requiredMessage')),
  items: Yup.array()
    .of(Yup.mixed())
    .required(t('requiredMessageItems'))
    .min(1, t('requiredMessageItems')),
})

export const hasSaleOrderItemCompletion = (
  values: GeneratePurchaseOrderValues,
  saleOrdersToPayload: Record<
    string,
    Record<string, GeneratePurchaseOrderPayloadSupplyItemProps[]>
  >,
) => {
  for (const saleOrder of values?.saleOrders || []) {
    for (const item of saleOrder.items || []) {
      const supplyItems =
        saleOrdersToPayload?.[saleOrder.uuid]?.[item.uuid] || []
      const totalSupplyQuantity = supplyItems.reduce(
        (acc, si) => acc + (Number(si.quantity) || 0),
        0,
      )
      if (totalSupplyQuantity < (Number(item?.missingQuantity) || 0)) {
        return false
      }
    }
  }
  return true
}
